import { ApiBind, Common } from "@app/core/models/common.model";
import { Parameter } from "@app/core/models/parameter.model";


/**
 * 広告リクエストフォーマットテンプレートのパラメータを表すモデル
 *
 * @exports
 */
export class AdRequestFormatTemplateParameter extends Parameter {
    @ApiBind({column: 'id'})
    id: number;

    @ApiBind({column: 'can_edit'})
    canEdit: boolean;
}

/**
 * 広告リクエストフォーマットテンプレート(ネイティブ)クラス
 * @remarks
 * 広告リクエストフォーマットテンプレート(ネイティブ)情報を格納するクラス
 */
export class AdRequestFormatTemplateNative extends Common {
    // 広告タイプ
    @ApiBind({ column: 'allox_ad_type' })
    alloxAdType: number;
}

/**
 * 広告リクエストフォーマットテンプレートクラス
 * @remarks
 * 広告リクエストフォーマットテンプレート情報を格納するクラス
 */
export class AdRequestFormatTemplate extends Common {
    // ID
    @ApiBind({ column: 'id' })
    id: number;
    // 広告リクエストフォーマットテンプレート名
    @ApiBind({ column: 'name' })
    name: string;
    // フォーマット
    @ApiBind({ column: 'format' })
    format: number;
    // 配信面
    @ApiBind({ column: 'delivery_scope' })
    deliveryScope: number;
    // 枠管理システムの配信システムID
    @ApiBind({ column: 'delivery_definition_id' })
    deliveryDefinitionId: number;
    // 配信面がネイティブ時の情報
    @ApiBind({
        column: 'native',
        model: (value) => value ? new AdRequestFormatTemplateNative(value) : null,
    })
    native: AdRequestFormatTemplateNative;
    // パラメータ
    @ApiBind({
        column: 'parameters',
        model: (values) => values.map((value) => new AdRequestFormatTemplateParameter(value)),
    })
    parameters: AdRequestFormatTemplateParameter[];

}
